import styled from 'styled-components'

export const FeedbackRestrictionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
`